(() => {
  'use strict';

  if (window.__delivingMeasurementV1) return;
  window.__delivingMeasurementV1 = true;

  const MEASUREMENT_ID = 'G-VVP4PG2SJ9';
  const CURRENCY = 'GBP';
  const SOURCE = 'deliving_measurement_v1';
  const startedForms = new WeakSet();

  const cleanText = (value, max = 100) =>
    String(value || '').replace(/\s+/g, ' ').trim().slice(0, max);

  const numberValue = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : undefined;
  };

  const send = (eventName, params = {}) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, {
      ...params,
      event_source: SOURCE,
      send_to: MEASUREMENT_ID,
    });
  };

  const itemFromDataset = (element, index) => {
    if (!(element instanceof HTMLElement)) return null;
    const item = {
      item_id: cleanText(element.dataset.trackingItemId, 150),
      item_name: cleanText(element.dataset.trackingProductName, 150),
      item_brand: cleanText(element.dataset.trackingProductVendor, 100),
      item_variant: cleanText(element.dataset.trackingVariant, 100),
      price: numberValue(element.dataset.trackingPrice),
      quantity: numberValue(element.dataset.trackingQuantity) || 1,
    };
    if (Number.isInteger(index)) item.index = index;
    Object.keys(item).forEach((key) => {
      if (item[key] === '' || item[key] === undefined) delete item[key];
    });
    return item.item_id || item.item_name ? item : null;
  };

  const currentProductItem = () => {
    const form = document.querySelector('product-form-component[data-product-id]');
    if (!(form instanceof HTMLElement)) return null;

    const productId = cleanText(form.dataset.productId, 80);
    const variantInput = form.querySelector('input[name="id"]');
    const variantId = cleanText(variantInput && variantInput.value, 80);
    const title = cleanText(document.querySelector('h1') && document.querySelector('h1').textContent, 150);

    const item = {
      item_id: productId && variantId ? 'shopify_ZZ_' + productId + '_' + variantId : productId,
      item_name: title,
      quantity: 1,
    };
    Object.keys(item).forEach((key) => {
      if (!item[key]) delete item[key];
    });
    return item.item_id || item.item_name ? item : null;
  };

  const cartRows = () => Array.from(document.querySelectorAll(
    'tr.cart-items__table-row[data-tracking-item-id]'
  ));

  const cartPayloadFromDom = () => {
    const items = cartRows().map((row, index) => itemFromDataset(row, index)).filter(Boolean);
    const value = items.reduce((sum, item) => {
      const price = Number(item.price || 0);
      const quantity = Number(item.quantity || 1);
      return sum + price * quantity;
    }, 0);
    return { items, value: Number(value.toFixed(2)) };
  };

  const trackViewCart = (source) => {
    const payload = cartPayloadFromDom();
    if (!payload.items.length) return;
    send('view_cart', {
      currency: CURRENCY,
      value: payload.value,
      items: payload.items,
      cart_view_source: source,
    });
  };

  const updateGoogleConsent = (detail) => {
    let analyticsAllowed;
    let marketingAllowed;

    if (detail && typeof detail.analyticsAllowed === 'boolean') analyticsAllowed = detail.analyticsAllowed;
    if (detail && typeof detail.marketingAllowed === 'boolean') marketingAllowed = detail.marketingAllowed;

    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy) {
        if (analyticsAllowed === undefined && typeof privacy.analyticsProcessingAllowed === 'function') {
          analyticsAllowed = Boolean(privacy.analyticsProcessingAllowed());
        }
        if (marketingAllowed === undefined && typeof privacy.marketingAllowed === 'function') {
          marketingAllowed = Boolean(privacy.marketingAllowed());
        }
      }
    } catch (_) {}

    if (typeof window.gtag !== 'function') return;
    if (analyticsAllowed === undefined && marketingAllowed === undefined) return;

    window.gtag('consent', 'update', {
      analytics_storage: analyticsAllowed === true ? 'granted' : 'denied',
      ad_storage: marketingAllowed === true ? 'granted' : 'denied',
      ad_user_data: marketingAllowed === true ? 'granted' : 'denied',
      ad_personalization: marketingAllowed === true ? 'granted' : 'denied',
    });
  };

  const initConsentBridge = (attempt = 0) => {
    if (!window.__delivingConsentListenerBound) {
      window.__delivingConsentListenerBound = true;
      document.addEventListener('visitorConsentCollected', (event) => {
        updateGoogleConsent(event && event.detail ? event.detail : null);
      });
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (!error) updateGoogleConsent();
        }
      );
      return;
    }

    if (attempt < 20) {
      window.setTimeout(() => initConsentBridge(attempt + 1), 250);
    }
  };

  const listNameForCard = (card) => {
    const section = card.closest('.shopify-section, section');
    const sectionHeading = section && section.querySelector('h2, h3');
    const pageHeading = document.querySelector('main h1, #MainContent h1, h1');
    return cleanText(
      (sectionHeading && sectionHeading.textContent) ||
      (pageHeading && pageHeading.textContent) ||
      document.title,
      100
    );
  };

  const trackCollectionDepth = () => {
    if (!location.pathname.startsWith('/collections/')) return;
    const cards = Array.from(document.querySelectorAll('product-card[data-tracking-item-id]'));
    if (!cards.length || !('IntersectionObserver' in window)) return;

    const seen = new Set();
    const sent = new Set();
    const thresholds = [25, 50, 75, 100];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const card = entry.target;
          const key = card.dataset.trackingItemId || card.dataset.productId;
          if (key) seen.add(key);
        }
      });

      const percentage = Math.round((seen.size / cards.length) * 100);
      thresholds.forEach((threshold) => {
        if (percentage >= threshold && !sent.has(threshold)) {
          sent.add(threshold);
          send('collection_depth', {
            collection_path: location.pathname,
            depth_percent: threshold,
            products_seen: seen.size,
            products_rendered: cards.length,
          });
        }
      });
    }, { threshold: [0.5] });

    cards.forEach((card) => observer.observe(card));
  };

  const formType = (form) => {
    if (!(form instanceof HTMLFormElement)) return null;
    if (form.classList.contains('email-signup__form')) return 'newsletter';
    if (location.pathname.includes('/contact') || String(form.action || '').includes('/contact')) return 'contact';
    return null;
  };

  document.addEventListener('focusin', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const form = target && target.closest('form');
    const type = formType(form);
    if (!type || startedForms.has(form)) return;

    startedForms.add(form);
    send(type === 'newsletter' ? 'newsletter_form_start' : 'contact_form_start', {
      form_type: type,
      page_path: location.pathname,
    });
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    const type = formType(form);
    if (!type) return;

    send(type === 'newsletter' ? 'newsletter_form_submit' : 'contact_form_submit', {
      form_type: type,
      page_path: location.pathname,
    });
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const productLink = target.closest('a[href*="/products/"]');
    const card = target.closest('product-card[data-tracking-item-id]');
    if (productLink && card) {
      const cards = Array.from(document.querySelectorAll('product-card[data-tracking-item-id]'));
      const item = itemFromDataset(card, Math.max(0, cards.indexOf(card)));
      if (item) {
        send('select_item', {
          item_list_name: listNameForCard(card),
          items: [item],
        });
      }
    }

    const removeButton = target.closest('.cart-items__remove');
    if (removeButton) {
      const row = removeButton.closest('tr.cart-items__table-row[data-tracking-item-id]');
      const item = itemFromDataset(row);
      if (item) {
        send('remove_from_cart', {
          currency: CURRENCY,
          value: Number(((item.price || 0) * (item.quantity || 1)).toFixed(2)),
          items: [item],
        });
      }
    }

    const wishlistControl = target.closest(
      '.deliving-wishlist-native-control, .deliving-wishlist-visual-button, [class*="wishlist"] button, [class*="wishlist"] a'
    );
    if (wishlistControl) {
      const label = cleanText(
        wishlistControl.getAttribute('aria-label') || wishlistControl.textContent,
        120
      );
      if (!/remove from wishlist|added to wishlist/i.test(label)) {
        const item = currentProductItem();
        if (item) send('add_to_wishlist', { currency: CURRENCY, items: [item] });
      }
    }

    const link = target.closest('a[href]');
    if (link) {
      const href = String(link.getAttribute('href') || '');
      const linkText = cleanText(link.textContent || link.getAttribute('aria-label'), 80);

      if (/^mailto:/i.test(href)) {
        send('email_click', { link_text: linkText, page_path: location.pathname });
        return;
      }

      if (/^tel:/i.test(href)) {
        send('phone_click', { link_text: linkText, page_path: location.pathname });
        return;
      }

      try {
        const url = new URL(link.href, location.href);
        if (/^https?:$/.test(url.protocol) && url.hostname && url.hostname !== location.hostname) {
          send('outbound_link_click', {
            link_domain: cleanText(url.hostname, 120),
            link_text: linkText,
            page_path: location.pathname,
          });
        }
      } catch (_) {}
    }

    if (location.pathname.startsWith('/products/')) {
      const clickable = target.closest('summary, button, a, [role="button"]');
      const label = cleanText(
        clickable && (clickable.getAttribute('aria-label') || clickable.textContent),
        120
      );
      if (clickable && /\b(delivery|shipping)\b/i.test(label)) {
        send('product_delivery_info_view', {
          interaction_label: label,
          page_path: location.pathname,
        });
      }
    }

    const cta = target.closest('a.button, button.button, [role="button"].button');
    if (cta &&
        !cta.closest('form') &&
        !cta.closest('.cart-items__quantity-controls') &&
        !cta.closest('[class*="wishlist"]') &&
        !cta.classList.contains('add-to-cart-button')) {
      const label = cleanText(cta.getAttribute('aria-label') || cta.textContent, 80);
      if (label) {
        send('cta_click', {
          cta_text: label,
          page_path: location.pathname,
        });
      }
    }
  }, true);

  document.addEventListener('filter:update', (event) => {
    if (!location.pathname.startsWith('/collections/')) return;
    const params = event && event.detail instanceof URLSearchParams ? event.detail : null;
    let filterCount = 0;
    let sortBy = '';
    if (params) {
      for (const [key, value] of params.entries()) {
        if (key.startsWith('filter.') && value) filterCount += 1;
        if (key === 'sort_by') sortBy = cleanText(value, 80);
      }
    }
    send('collection_filter', {
      collection_path: location.pathname,
      active_filter_count: filterCount,
      sort_by: sortBy,
    });
  });

  document.addEventListener('slideshow:select', (event) => {
    if (!location.pathname.startsWith('/products/')) return;
    if (!event.detail || event.detail.userInitiated !== true) return;

    send('product_gallery_interaction', {
      media_index: Number(event.detail.index || 0) + 1,
      interaction_type: cleanText(event.detail.trigger, 40),
      page_path: location.pathname,
    });
  });

  const initialEvents = () => {
    initConsentBridge();

    if (location.pathname === '/cart' || location.pathname.startsWith('/cart/')) {
      window.setTimeout(() => trackViewCart('cart_page'), 0);
    }

    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && cartDrawer.dataset.delivingTrackingBound !== 'true') {
      cartDrawer.dataset.delivingTrackingBound = 'true';
      cartDrawer.addEventListener('dialog:open', () => {
        window.setTimeout(() => trackViewCart('cart_drawer'), 50);
      });
    }

    trackCollectionDepth();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialEvents, { once: true });
  } else {
    initialEvents();
  }
})();